export const BLANK = {
  id: null,
  value: null,
  label: 'Blank',
};
